import { Box, Divider, Text } from '@doist/marketist';
import cn from 'clsx';
import { ProductUIBoxShadow } from '../product-ui-box-shadow/product-ui-box-shadow';
import css from './product-ui-context-menu.module.css';
import type { CSSProperties, ReactNode } from 'react';
export type AbsolutePlacement = {
  top?: number;
  left?: number;
  bottom?: number;
  right?: number;
};
type ProductUIContextMenuProps = {
  id?: string;
  title?: string;
  children: React.ReactNode;
  className?: string;
  placement?: AbsolutePlacement;
  padding?: string;
  width?: number;
};
export function ProductUIContextMenu({
  id,
  children,
  title,
  className,
  placement = {
    top: 0,
    right: 0
  },
  width,
  padding,
  ...rest
}: ProductUIContextMenuProps) {
  const customProps = {
    '--context-menu-top': placement.top ? `${placement.top}px` : undefined,
    '--context-menu-left': placement.left ? `${placement.left}px` : undefined,
    '--context-menu-bottom': placement.bottom ? `${placement.bottom}px` : undefined,
    '--context-menu-right': placement.right ? `${placement.right}px` : undefined,
    '--context-menu-width': width ? `${width}px` : undefined,
    '--context-menu-padding': padding
  } as CSSProperties;
  return <Box id={id} className={cn(css.contextMenu, className)} style={customProps} {...rest} data-sentry-element="Box" data-sentry-component="ProductUIContextMenu" data-sentry-source-file="product-ui-context-menu.tsx">
            <ProductUIBoxShadow data-sentry-element="ProductUIBoxShadow" data-sentry-source-file="product-ui-context-menu.tsx" />
            {title ? <>
                    <Text className={css.header} size="minor-sm" weight="semibold">
                        {title}
                    </Text>
                    <Divider semantic={false} />
                </> : null}
            <div className={css.listItemContainer}>{children}</div>
        </Box>;
}
export type ProductUIContextMenuHeadingProps = {
  children?: ReactNode;
};
export function ProductUIContextMenuHeading({
  children
}: ProductUIContextMenuHeadingProps) {
  return <Text className={css.contextMenuHeading} size="minor-sm" weight="semibold" data-sentry-element="Text" data-sentry-component="ProductUIContextMenuHeading" data-sentry-source-file="product-ui-context-menu.tsx">
            {children}
        </Text>;
}